import { notification } from "antd";
import cuid from "cuid";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useMutation } from "shared/hooks/useApi";
import { useSignUpAuth } from "shared/hooks/useSignUpAuth";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { USER_TYPES } from "utils/constants";
import View from "./View";

const Duplicate = ({ open, organization, onClose }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.BROKER);
  const FORM = t("FORM", { returnObjects: true });
  const DUPLICATE = t("DUPLICATE", { returnObjects: true });
  const { t: errors } = useTranslation(NAME_SPACES.ERRORS);
  const API_ERRORS = errors("API", { returnObjects: true });

  const [signUpAuth] = useSignUpAuth({
    onError: () => notification.error({ message: FORM.IN_USE }),
  });
  const [signUp] = useMutation(graphql.mutations.SIGN_UP);
  const [updateUser] = useMutation(graphql.mutations.UPDATE_USER_AUTH);
  const [duplicateOrganization, { loading }] = useMutation(
    graphql.mutations.DUPLICATE_ORGANIZATION,
    {
      refetchQueries: ["brokers"],
      awaitRefetchQueries: true,
      onCompleted: () => {
        notification.success({ message: DUPLICATE.SUCCESS });
        onClose();
      },
    },
  );

  const releaseIdentity = (id) => {
    updateUser({
      variables: {
        where: { id },
        data: { phone: null, username: null, email: null, password: null },
      },
    });
    notification.error({ message: API_ERRORS.GENERIC });
  };

  const onSubmit = ({ name, email, entities, user }) => {
    const userId = cuid();
    const organizationId = cuid();
    signUpAuth({
      variables: {
        data: {
          id: userId,
          ...user,
          username: email,
          email,
          password: cuid(),
          meta: { type: USER_TYPES.INSURANCE_ADMIN.type },
          organization: { id: organizationId, name },
        },
      },
      onCompleted: ({ signUp: authResult }) =>
        signUp({
          variables: {
            data: {
              user: {
                id: userId,
                ...user,
                email,
                username: email,
                isActive: true,
                meta: {
                  type: USER_TYPES.INSURANCE_ADMIN.type,
                  ...get(authResult, "meta", {}),
                },
              },
              baseUrl: process.env.REACT_APP_BASE_URL,
            },
          },
          onError: () => releaseIdentity(userId),
          onCompleted: () =>
            duplicateOrganization({
              variables: {
                where: { id: get(organization, "id") },
                data: {
                  id: organizationId,
                  name,
                  entities,
                  users: [{ id: userId }],
                },
              },
              onError: () => releaseIdentity(userId),
            }),
        }),
    });
  };

  return (
    <View
      open={open}
      organization={organization}
      onClose={onClose}
      onSubmit={onSubmit}
      loading={loading}
    />
  );
};

export default Duplicate;
